"use client";
import { Breadcrumb } from "@/types/Breadcrumb";
import { useLocalityService } from '@/providers/Locality';
import { faHome } from "@fortawesome/free-solid-svg-icons/faHome";
import { Icon } from "@/theme/components/Icon";
import { toIconSvg } from "@/utilities/iconSvg";

const homeIcon = toIconSvg(faHome);
import Link from "next/link";
import { usePathname } from "next/navigation";

const LocalityBreadcrumbs = ({
  breadcrumbs,
}: {
  breadcrumbs?: Breadcrumb[] | null | undefined;
}) => {
  const pathname = usePathname();
  const localityService = useLocalityService();
  const lastBreadcrumb = breadcrumbs
    ? breadcrumbs[breadcrumbs?.length - 1]
    : null;

  return (
    <nav
      aria-label="Breadcrumb"
      className="relative flex w-full border-b border-gray-200 bg-white lg:z-10 lg:pt-0 "
    >
      <ol
        role="list"
        className="flex w-full max-w-screen-xl space-x-4 px-4 sm:px-6 lg:px-8"
      >
        <li className="flex">
          <div className="flex items-center">
            <Link href="/" className="text-gray-500 hover:text-gray-300">
              <Icon icon={homeIcon} className="size-5  shrink-0" />
              <span className="sr-only">Accueil</span>
            </Link>
          </div>
        </li>
        {breadcrumbs &&
          breadcrumbs.length > 0 &&
          breadcrumbs.map((segment, index) => (
            <li key={index} className="flex">
              <div className="flex items-center ">
                <svg
                  viewBox="0 0 24 44"
                  fill="currentColor"
                  preserveAspectRatio="none"
                  aria-hidden="true"
                  className="h-full w-6 shrink-0 text-gray-300"
                >
                  <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                </svg>
                <Link
                  href={segment.url || "/"}
                  className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-300"
                >
                  {segment.label}
                </Link>
              </div>
            </li>
          ))}
        {lastBreadcrumb && (
          <li className="flex">
            <div className="flex items-center ">
              <svg
                viewBox="0 0 24 44"
                fill="currentColor"
                preserveAspectRatio="none"
                aria-hidden="true"
                className="h-full w-6 shrink-0 text-gray-300"
              >
                <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
              </svg>
              <Link
                href={pathname}
                className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-300"
              >
                {localityService?.replaceTags(
                  `${lastBreadcrumb.label} à *##locality##*`,
                )}
              </Link>
            </div>
          </li>
        )}
      </ol>
    </nav>
  );
};

export default LocalityBreadcrumbs;
